import { Link } from 'react-router-dom';

const blocks = [
  {
    tag: '天然原料',
    title: '天然來源萃取，好的營養就從原料把關',
    desc: '康永生技堅持天然選材，用食物的天然營養守住你的健康',
    points: [
      '動物來源：嚴選友善環境之動物來源，專業萃取之頂級營養',
      '植物來源：天然栽種之植物萃取精華，從自然中養出健康',
      '菇蕈來源：優質環境培養菇蕈，健康維持更有力',
      '藻類油脂：天然來源油脂，負擔減少、營養加倍',
      '生化類群：採用天然專業製程、零化工殘留，健康不留白',
    ],
    img: 'https://readdy.ai/api/search-image?query=natural%20herb%20botanical%20raw%20ingredients%20turmeric%20ginger%20green%20tea%20extract%20dried%20herbs%20spices%20arranged%20on%20white%20wooden%20surface%2C%20health%20supplement%20raw%20materials%20professional%20photography&width=720&height=500&seq=service-raw-01&orientation=landscape',
    imgLeft: false,
  },
  {
    tag: '生產製造',
    title: '國際認證規範廠房，多劑型生產能力',
    desc: '康永生技廠房達到國際認證規範標準，具備膠囊、錠劑、粉末、液態等多種劑型的完整生產線。從小量試產到大量量產，靈活配合客戶需求，確保每批次品質穩定一致。',
    points: [
      '符合國際規範認證的潔淨生產環境',
      '膠囊、錠劑、粉包、飲品多線並行',
      '支援小量試產（3,000 起）至大量量產',
      '全程溫溼度監控記錄',
    ],
    img: 'https://readdy.ai/api/search-image?query=GMP%20certified%20health%20supplement%20production%20line%20workers%20wearing%20white%20uniform%20hairnet%20operating%20manufacturing%20equipment%20in%20clean%20room%2C%20professional%20pharmaceutical%20factory%20interior&width=720&height=500&seq=service-prod-01&orientation=landscape',
    imgLeft: true,
  },
];

export default function ServiceImageTextSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            天然原料
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">天然來源萃取，好的營養就從原料把關</h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技堅持天然選材，用食物的天然營養守住你的健康
          </p>
        </div>

        <div className="space-y-16">
          {blocks.map((block) => (
            <div
              key={block.title}
              className={`flex flex-col ${block.imgLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-10 lg:gap-16 items-center`}
            >
              <div className="w-full lg:w-1/2">
                <span className="inline-block bg-green-100 text-[#4CAF50] text-[0.8125rem] font-medium px-3 py-1 rounded-full mb-4">
                  {block.tag}
                </span>
                <h3 className="text-[#1a2e1a] font-bold text-[1.625rem] leading-tight mb-4">{block.title}</h3>
                <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-6">{block.desc}</p>
                <ul className="space-y-3">
                  {block.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-3">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg" />
                      </div>
                      <span className="text-gray-600 text-[0.9375rem] leading-[1.75]">{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="w-full lg:w-1/2 flex-shrink-0">
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src={block.img}
                    alt={block.title}
                    className="w-full h-[320px] lg:h-[380px] object-cover object-top rounded-2xl"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
